import { getClient as e, registerEntityEndpoint as t } from "@editor/ui-utils";
//#region \0plugin-vue:export-helper
var n = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, r = t("tags"), { getEntity: i, listEntities: a, putEntity: o, postEntity: s, deleteEntity: c } = r, l = async (e) => i(e), u = async (e) => s(e), d = async (e) => {
	let { _id: t, ...n } = e;
	return o(t, n);
}, f = async (e) => c(e), p = async (t, n) => (await e().put(`/cms/tags/${t}/legacy-migration`, n)).data, m = async (t) => (await e().get(`/cms/tags/${t}/check-path-conflict`)).data, h = ["People"], g = [{
	tagsType: "People",
	blockType: "PEOPLE_PROFILE",
	icon: "star"
}];
//#endregion
export { f as a, d as c, m as i, p as l, h as n, l as o, r, u as s, g as t, n as u };

//# sourceMappingURL=types-C27lFQz7.js.map